import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Icon } from "semantic-ui-react";

// Blocos de tela de cadastro/edição no padrão novo (cabeçalho, seção, opção liga/desliga, rodapé).
// Estilos: .va-imp-* e .va-un-cabecalho em theme.css.

export const CabecalhoForm = ({ voltar, voltarTexto, titulo, descricao }) => (
  <header className="va-un-cabecalho">
    <div>
      {!!voltar && (
        <Link to={voltar} className="va-edit-voltar"><Icon name="arrow left" /> {voltarTexto || "Voltar"}</Link>
      )}
      <h1>{titulo}</h1>
      {!!descricao && <p>{descricao}</p>}
    </div>
  </header>
);

export const SecaoForm = ({ icone, titulo, descricao, children }) => (
  <section className="va-imp-bloco">
    {!!titulo && <h3>{icone && <Icon name={icone} />} {titulo}</h3>}
    {!!descricao && <p>{descricao}</p>}
    {children}
  </section>
);

// Interruptor em cartão, com título e frase de explicação.
export const OpcaoForm = ({ ativa, onChange, titulo, descricao, disabled, name }) => (
  <label className={`va-imp-opcao ${ativa ? "ativa" : ""} ${disabled ? "desabilitada" : ""}`}>
    <input type="checkbox" name={name} checked={!!ativa} onChange={onChange} disabled={disabled} />
    <span className="va-imp-chave" aria-hidden="true" />
    <span>
      <b>{titulo}</b>
      {!!descricao && <small>{descricao}</small>}
    </span>
  </label>
);

export const AvisoForm = ({ tipo, icone, children }) => (
  <div className={`va-imp-resumo ${tipo || ""}`}>
    <Icon name={icone || "info circle"} loading={icone === "spinner"} />
    <span>{children}</span>
  </div>
);

export const RodapeForm = ({ children }) => <div className="va-imp-acoes">{children}</div>;

// Indicador de etapas: etapas = ["Sobre a reunião", "Perguntas"], atual = 0
export const EtapasForm = ({ etapas, atual }) => (
  <ol className="va-imp-passos" aria-label="Etapas">
    {etapas.map((nome, i) => (
      <li key={nome} className={i === atual ? "ativo" : i < atual ? "feito" : ""}>
        <span>{i < atual ? <Icon name="check" /> : i + 1}</span> {nome}
      </li>
    ))}
  </ol>
);

CabecalhoForm.propTypes = { titulo: PropTypes.string.isRequired };
SecaoForm.propTypes = { children: PropTypes.node };
OpcaoForm.propTypes = { titulo: PropTypes.string.isRequired, onChange: PropTypes.func.isRequired };
EtapasForm.propTypes = { etapas: PropTypes.arrayOf(PropTypes.string).isRequired, atual: PropTypes.number.isRequired };

// Área de seleção de arquivo (clique ou arraste). Mostra o arquivo escolhido ou o já existente.
export const AreaArquivo = ({
  id, arquivo, accept, onChange, icone = "file pdf outline", titulo, dica, erro,
  existenteUrl, existenteTexto = "Ver arquivo atual", onConfirmar, confirmando, textoConfirmar = "Confirmar alteração",
}) => (
  <div className="va-area-arquivo">
    <label htmlFor={id} className={`va-imp-zona compacta ${arquivo ? "com-arquivo" : ""} ${erro ? "erro" : ""}`}>
      <Icon name={arquivo ? icone : "cloud upload"} size="large" />
      <span className="va-imp-zona-texto">
        <b>{arquivo ? arquivo.name : titulo}</b>
        {!arquivo && !!dica && <small>{dica}</small>}
        {!!arquivo && <small>Arquivo selecionado</small>}
      </span>
      <input type="file" id={id} name={id} accept={accept} onChange={onChange} className="va-imp-input" />
    </label>
    {!!existenteUrl && (
      <a href={existenteUrl} target="_blank" rel="noopener noreferrer" className="va-area-arquivo-link">
        <Icon name="external alternate" /> {existenteTexto}
      </a>
    )}
    {!!arquivo && !!onConfirmar && (
      <button type="button" className="ui button btn-ui-1 small" onClick={onConfirmar} disabled={confirmando}>
        {confirmando ? "Enviando..." : textoConfirmar}
      </button>
    )}
    {!!erro && <div className="va-area-arquivo-erro">{erro}</div>}
  </div>
);
